// extracted by mini-css-extract-plugin
export default {"separator":"OAuth_separator__pnZL3","divider":"OAuth_divider__OJRo+","logo":"OAuth_logo__cuTPb","btn":"OAuth_btn__CFE2B"};